import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { activateBusinessPaymentAction } from "../../actions/businessInfo";
import TimeFormat from "../../components/timeFormat/timeFormat";
import ActivationPlanModal from "./ActivationPlanModal";

export default function CompanyDetail({ addModalShow, addModalClose, item, filterBody }) {
    const dispatch = useDispatch();
    const [company, setCompany] = useState(item);
    const [activationLoading, setActivationLoading] = useState(false);
    const [manualActivationModalShow, setManualActivationModalShow] = useState(false);

    useEffect(() => {
        setCompany(item);
    }, [item]);

    if (!item) return null;

    const isAdvisor = company?.isDefault === true;
    const canActivateBusiness =
        company?.isActive === true &&
        company?.isAdminApproved === true &&
        company?.isBusinessActivate !== true;
    const canActivateAfterPayment =
        canActivateBusiness &&
        !!company?.businessActivationPayment;
    const canActivateManually =
        canActivateBusiness &&
        !company?.businessActivationPayment;

    const requestedBy =
        company?.user?.length
            ? `${company.user[0].first_name} ${company.user[0].last_name}`
            : "-";

    const Field = ({ label, value, col = 6 }) => (
        <div className={`col-md-${col} mb-3`}>
            <h6 className="mb-1">{label}</h6>
            <div className="fw-semibold">{value || "-"}</div>
        </div>
    );

    const LinkField = ({ label, value }) => (
        <div className="col-md-6 mb-3 updateDetail">
            <h6 className="mb-1">{label}</h6>
            {value ? (
                <a
                    href={value.startsWith("http") ? value : `https://${value}`}
                    target="_blank"
                    rel="noreferrer"
                >
                    {value}
                </a>
            ) : (
                "-"
            )}
        </div>
    );

    const handleActivatePayment = async () => {
        setActivationLoading(true);
        const resp = await dispatch(activateBusinessPaymentAction({ companyId: company?._id }, filterBody));
        setActivationLoading(false);
        const updatedCompany = resp.company || resp.data?.company;
        if (resp.status && updatedCompany) {
            setCompany(updatedCompany);
        }
    };

    return (
        <>
            <Modal show={addModalShow} onHide={addModalClose} centered size="lg">
                <div className="modal-header border-0 pb-0">
                    <h5 className="fw-bold">
                        {isAdvisor ? "Advisor detail" : "Company detail"}
                    </h5>

                    <button className="btn-close" onClick={addModalClose} />
                </div>

                <div className="modal-body pt-2">

                    <div className="row mb-2">
                        <div className="col-12">
                            <h6 className="mb-0">
                                {isAdvisor ? "Advisor name" : "Company name"}
                            </h6>

                            <h4 className="fw-bold">
                                {isAdvisor ? requestedBy : company?.companyName || "-"}
                            </h4>
                        </div>
                    </div>

                    <div className="row">

                        {!isAdvisor && (
                            <Field
                                label="Requested by"
                                value={requestedBy}
                            />
                        )}

                        {isAdvisor && (
                            <Field
                                label="Country"
                                value={company?.country}
                            />
                        )}

                        {!isAdvisor && (
                            <>
                                <Field
                                    label="Primary activity"
                                    value={company?.primaryActivity}
                                />

                                <Field
                                    label="Secondary activity"
                                    value={company?.secondaryActivity}
                                />
                            </>
                        )}

                        {isAdvisor && (
                            <LinkField
                                label="LinkedIn profile"
                                value={company?.linkedInUrl}
                            />
                        )}

                        {isAdvisor && (
                            <Field
                                label="Skills"
                                col={12}
                                value={
                                    company?.skills?.length
                                        ? company.skills.join(", ")
                                        : "-"
                                }
                            />
                        )}

                        {!isAdvisor && (
                            <LinkField
                                label="Company website"
                                value={company?.companyWebsite}
                            />
                        )}
                    </div>


                    <div className="row">
                        <Field
                            col={12}
                            label={isAdvisor ? "About me" : "About company"}
                            value={company?.about}
                        />
                    </div>

                    {!isAdvisor && (
                        <div className="row mt-2">
                            <div className="col-12">
                                <h5 className="fw-bold mb-3">Business activation</h5>
                            </div>
                            {company?.isBusinessActivate === true ? (
                                <>
                                    <Field label="Plan name" value={company?.businessActivationPlanName} />
                                    <Field label="Expiry date" value={company?.businessActivationExpiryDate} />
                                    <div className="col-md-6 mb-3">
                                        <h6 className="mb-1">Activated at</h6>
                                        <div className="fw-semibold">
                                            {company?.businessActivatedAt ? <TimeFormat time={company.businessActivatedAt} /> : "-"}
                                        </div>
                                    </div>
                                    <Field col={12} label="Plan detail" value={company?.businessActivationPlanDetail} />
                                </>
                            ) : (
                                canActivateBusiness && (
                                    <div className="col-12 d-flex gap-2 flex-wrap">
                                        {canActivateAfterPayment && (
                                            <button
                                                className="btn save-btn editButton"
                                                onClick={handleActivatePayment}
                                                disabled={activationLoading}
                                            >
                                                {activationLoading ? "Activating..." : "Activate Business"}
                                            </button>
                                        )}
                                        {canActivateManually && (
                                            <button
                                                className="btn save-btn editButton"
                                                onClick={() => setManualActivationModalShow(true)}
                                                disabled={activationLoading}
                                            >
                                                Activate Manually
                                            </button>
                                        )}
                                    </div>
                                )
                            )}
                        </div>
                    )}

                    <div className="text-end mt-3">
                        <button
                            className="btn btn-secondary px-4"
                            onClick={addModalClose}
                        >
                            Back
                        </button>
                    </div>

                </div>
            </Modal>
            <ActivationPlanModal
                show={manualActivationModalShow}
                onClose={() => setManualActivationModalShow(false)}
                company={company}
                filterBody={filterBody}
                onActivated={(updatedCompany) => updatedCompany && setCompany(updatedCompany)}
            />
        </>
    );
}
